module.exports = __webpack_public_path__ + "static/media/logo.a800ae2d.png";